/**
 * Live-resize preview: while the producer drags an assignment's edge the
 * working copy lives in `resizing.assignment`; the persisted array is only
 * updated on mouse-up. Rendering through this helper makes the block track
 * the drag in real time instead of jumping on release.
 */

export interface AssignmentTimes {
  filming_start: string;
  filming_end: string;
}

export interface ResizePreview<T extends AssignmentTimes> {
  assignment: T;
  originalAssignment: T;
}

export function getEffectiveAssignmentTimes<T extends AssignmentTimes>(
  assignment: T,
  resizing: ResizePreview<T> | null | undefined,
  matches: (a: T, b: T) => boolean,
): AssignmentTimes {
  if (resizing && matches(assignment, resizing.originalAssignment)) {
    return resizing.assignment;
  }
  return assignment;
}
